import { useResizeObserver } from '@vueuse/core';
// @ts-ignore
import { spring } from 'vue3-spring';
export const useBlockExpandable = (
  blockEl: Ref<HTMLElement>,
  headerEl: Ref<HTMLElement>,
  contentEl: Ref<HTMLElement>,
  defautState: 'opened' | 'closed' | 'none' = 'opened'
) => {
  const expanded = ref(defautState === 'opened' || defautState === 'none');
  const heightOpenedEl = ref(0);
  const heightClosedEl = ref(0);
  const expandValue = ref(0);
  const animate = ref(false);
  const expandSpring = spring(expandValue, {
    damping: 15,
    stiffness: 180,
    mass: 0.96,
  });

  useResizeObserver(contentEl, () => {
    const bordersHeight =
      parseInt(
        getComputedStyle(blockEl.value, null).getPropertyValue('border-width')
      ) * 2 || 4;
    heightOpenedEl.value = (blockEl.value?.scrollHeight || 0) + bordersHeight;
    heightClosedEl.value = (headerEl.value?.scrollHeight || 0) + bordersHeight;
  });

  const isReady = computed(() => {
    return heightClosedEl.value > 0;
  });
  const styledBlock = computed(() => {
    if (defautState === 'none') return;
    if (!animate.value) {
      return { maxHeight: `${expandValue.value}px` };
    } else {
      return {
        maxHeight: `${expandSpring.value}px`,
        height: `${expandSpring.value}px`,
      };
    }
  });

  watch(isReady, (to) => {
    if (to) {
      expandValue.value = expanded
        ? heightOpenedEl.value
        : heightClosedEl.value;
    }
  });

  watchEffect(() => {
    if (expanded.value) {
      expandValue.value = heightOpenedEl.value;
      expandSpring.value = heightOpenedEl.value;
    } else {
      expandValue.value = heightClosedEl.value;
      expandSpring.value = heightClosedEl.value;
    }
  });

  const handler = (e) => {
    animate.value = true;
    expanded.value = !expanded.value;
  };

  return { style: styledBlock, isReady, handler, expanded };
};
